import React, { useEffect } from 'react';
import { Form, Input, Button, Checkbox } from 'antd';
import {isDisabled} from "@testing-library/user-event/dist/utils";

const PartnerForm = ({ handleSubmitPartner, editingPartner }) => {
    const [form] = Form.useForm();

    useEffect(() => {
        if (editingPartner) {
            form.setFieldsValue(editingPartner);
        } else {
            form.resetFields();
        }
    }, [editingPartner]);

    const onFinish = (values) => {
        const finalData = editingPartner
            ? { ...editingPartner, ...values }
            : { ...values };

        handleSubmitPartner(finalData);
        form.resetFields();
    };

    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
            style={{ maxWidth: 600, marginBottom: 24 }}
        >
            <Form.Item
                label="Tên đối tác"
                name="name"
                rules={[{ required: true, message: 'Vui lòng nhập tên!' }]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                label="Mã đối tác"
                name="code"
                rules={[{ required: true, message: 'Vui lòng nhập mã code!' }]}
            >
                <Input />
            </Form.Item>

            <Form.Item label="Mô tả" name="description">
                <Input.TextArea />
            </Form.Item>

            <Form.Item name="active" valuePropName="checked">
                <Checkbox>Đang hoạt động</Checkbox>
            </Form.Item>

            <Form.Item>
                <Button type="primary" htmlType="submit">
                    Lưu đối tác
                </Button>
            </Form.Item>
        </Form>
    );
};

export default PartnerForm;
